import React from 'react';
import { FONTS, ThemedSVGProps } from '@/styles';
import { StyleSheet, Text, TouchableOpacity } from 'react-native';
import { SvgProps } from 'react-native-svg';

interface Props {
  backgroundColor: string;
  Icon: React.FC<SvgProps>;
  iconProps: ThemedSVGProps;
  onPress: () => void;
  text: string;
}

export const LocationPickerRightAction: React.FC<Props> = ({
  backgroundColor,
  Icon,
  iconProps,
  onPress,
  text,
}) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={[styles.base, { backgroundColor }]}
    >
      <Icon height={21} width={21} {...iconProps} />
      <Text numberOfLines={2} style={styles.text}>
        {text}
      </Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  base: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
  text: {
    ...FONTS.primarySemiBold,
    flexShrink: 0,
    fontSize: 11,
    lineHeight: 14,
    marginHorizontal: 0,
    marginTop: 4,
    textAlign: 'center',
  },
});
